module.exports = __webpack_public_path__ + "img/intro-bg.80ed283a.jpg";